import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StormService, SharedService } from './../../../services';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'widget-storm',
  templateUrl: './storm.component.html',
  styleUrls: ['./storm.component.scss'],
  host: {
    "(click)": "goToDetails()"
  },
  encapsulation: ViewEncapsulation.Emulated
})
export class StormComponent implements OnInit {

  constructor(
    private _storm: StormService,
    private _sanitizer: DomSanitizer,
    private _router: Router,
    private _shared: SharedService
  ) { }

  loading = false;
  // data;
  showStorm;
  text;
  res;
  date;
  date2;
  time;

  // getTrueText(html) {
  //   return this._sanitizer.bypassSecurityTrustHtml(html);
  // }

  goToDetails() {
    this._router.navigate(['weather/weather-warnings']);
  }

  checkDate() {
    let isStorm = this.date > new Date().getTime();
    this.showStorm = isStorm;
    this._shared.changeLevelWidget(this.showStorm && this.res._show);
    return isStorm;
  }

  getCurrent() {
    this.loading = true;
    this._storm.getLevel().subscribe(
      res => {
        // this.data = res[0].storm;
        this.res = res[0];
        this.text = this._sanitizer.bypassSecurityTrustHtml(this.res.text);
        this.time = res[0].activeTime.split(':');
        this.date = new Date(new Date(res[0].activeDate).setHours(Number(this.time[0]), Number(this.time[1]))).getTime();
        this.date2 = new Date().getTime();
        this.showStorm = this.date > this.date2;
        this._shared.changeLevelWidget(this.showStorm && this.res._show);
        this.loading = false;
      },
      err => {
        console.error(err);
        this._shared.changeLevelWidget(false);
        this.loading = false;
      }
    )
  }

  ngOnInit() {
    this.getCurrent();
  }

}
